import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MetadataApiService } from '../metadata-api/metadata-api.service';
import { QueryParamsService } from 'src/app/shared/utils/query-params.service';
import {
  CommodityQueryRequest,
  CompanyQueryRequest,
  EntityEnrichmentRequest,
  EntityEnrichmentResponse,
  LexiconResponse,
  TopicQueryRequest,
  YukkaQuery,
} from '../../models/ai-search.interface';

export interface AiGeneratedQueryData {
  name: string;
  description: string;
  query: YukkaQuery;
  groups: unknown[];
  _isAiGenerated: true;
}

@Injectable({ providedIn: 'root' })
export class AiSearchService {
  pendingLegalName: string | null = null;
  lastGeneratedQueryData: AiGeneratedQueryData | null = null;

  constructor(
    private metadataApi: MetadataApiService,
    private queryParamsService: QueryParamsService,
  ) {}

  getLanguages(): string[] {
    const lang = this.queryParamsService.queryParams?.lang;
    if (lang && lang !== 'multi') {
      return lang.split(',');
    }
    return ['en'];
  }

  generateCompanyQuery(
    request: CompanyQueryRequest,
  ): Observable<LexiconResponse> {
    return this.metadataApi.post<LexiconResponse>('generate/company', request);
  }

  generateTopicQuery(request: TopicQueryRequest): Observable<LexiconResponse> {
    return this.metadataApi.post<LexiconResponse>('generate/topic', request);
  }

  generateCommodityQuery(
    request: CommodityQueryRequest,
  ): Observable<LexiconResponse> {
    return this.metadataApi.post<LexiconResponse>(
      'generate/commodity',
      request,
    );
  }

  generateEntityEnrichment(
    request: EntityEnrichmentRequest,
  ): Observable<EntityEnrichmentResponse> {
    return this.metadataApi.post<EntityEnrichmentResponse>(
      'generate/entity-enrichment',
      request,
    );
  }
}
